// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import {
  getNestedByString,
  setNestedValueInObject,
} from 'helpers/reduxFormFunctions'

import {
  assembleQuery,
  fetchAntennaCompanies,
  fetchRadioCompanies,
} from 'helpers/api'

import {
  INVALID_ANTENNA_MANUFACTURER,
  INVALID_RADIO_MANUFACTURER,
  UNCAUGHT_ERROR,
} from 'errors'

// This is an async validation method to verify that a manufacturer (company) is valid for the
// specified hardware type. The supported hardware types are 'antenna' and 'radio'
export const manufacturerIsValid = async (formValues, f, props, pathString, hardwareType) => {
  const {
    asyncErrors = {},
    change,
    dispatch,
    form,
  } = props

  const hasAsyncErrors = Object.keys(asyncErrors).length
  // the id value has no corresponding input value in the DOM.
  // so to validate the id asynchronously, trigger this validation
  // method when user blurs on the antenna family input field.
  const v = getNestedByString(formValues, pathString)

  if (!hasAsyncErrors && !v.length) {
    return
  } else if (!v.length) {
    // even if there's no value, throw the asyncErrors object since
    // there may already be other async errors that we want to keep
    throw asyncErrors
  }

  // to reduce repetition below
  const err = {
    message: hardwareType === 'antenna' ? INVALID_ANTENNA_MANUFACTURER : INVALID_RADIO_MANUFACTURER,
  }

  const fetchHardwareCompanies = (
    hardwareType === 'antenna'
      ? fetchAntennaCompanies
      : fetchRadioCompanies
  )

  const query = [{
    field: 'companyContains',
    value: v,
  }]

  try {
    const { entities } = await fetchHardwareCompanies(assembleQuery(query))

    // in case we have an uncaught exception in the API
    if (!entities) {
      throw err
    }

    const ent = entities.find(d => d.companyName.toLowerCase() === v.toLowerCase())

    if (!ent) {
      throw err
    }

    // assign the company name that was selected
    dispatch(change(pathString, ent.companyName))

    // on the db search screen, we want to look for things by their string values
    // but when creating entities, we need to use their ids on POST and PUT
    if (hardwareType === 'antenna' && form !== 'antenna-db-search') {
      const ci = 'companyId'
      const civ = ent[ci]
      dispatch(change(ci, civ))
    }
  } catch (error) {
    console.warn(error)

    // clear the id but leave the antenna family name so the user can put focus
    // on the input and refetch any possible suggestions again.
    dispatch(change(`${pathString}Id`, ''))

    setNestedValueInObject(asyncErrors, pathString, error.message || UNCAUGHT_ERROR)
    throw asyncErrors
  }

  // even though everything went smoothly, we need to persist
  // any other async errors which are present
  if (hasAsyncErrors) {
    throw asyncErrors
  }
}
